import Vue from 'vue';
import Vuex from 'vuex';
import createPersist from 'vuex-localstorage';
import ships from './modules/ships';
import ui from './modules/ui';
import audio from './modules/audio';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
if (debug) {
  console.warn(`Vuex is in STRICT mode as NODE_ENV is set to "${process.env.NODE_ENV}".\n
All commits are syncronously watched. Performance lag is due to this.`);
}

export default new Vuex.Store({
  plugins: [
    createPersist({
      namespace: 'bikini-atoll',
      initialState: {
        muteAudio: true,
      },
      paths: ['audio'],
      expires: 0, // Never expire
    }),
  ],
  modules: {
    ships,
    ui,
    audio,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./store/index.js